import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslations from '../public/locales/en/translation.json';
import esTranslations from '../public/locales/es/translation.json';
import ptTranslations from '../public/locales/pt/translation.json';

import { resolveInitialAppLanguage } from './shared/config';

const resources = {
  en: {
    translation: enTranslations,
  },
  pt: {
    translation: ptTranslations,
  },
  es: {
    translation: esTranslations,
  },
} as const;

i18n.use(initReactI18next).init({
  resources,
  lng: resolveInitialAppLanguage() ?? undefined,
  supportedLngs: ['en', 'pt', 'es'],
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  debug: false,
});

export default i18n;
